import { render } from "./RegionField.vue?vue&type=template&id=68a974af"
import script from "./RegionField.vue?vue&type=script&lang=js"
export * from "./RegionField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__